import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19.396 11.056a6 6 0 0 1 -5.647 10.506q .206 -.21 .396 -.44a8 8 0 0 0 1.789 -6.155a8.02 8.02 0 0 0 3.462 -3.911","key":"svg-0"}],["path",{"d":"M4.609 11.051a7.99 7.99 0 0 0 9.386 4.698a6 6 0 1 1 -9.534 -4.594z","key":"svg-1"}],["path",{"d":"M12 2a6 6 0 1 1 -6 6l.004 -.225a6 6 0 0 1 5.996 -5.775","key":"svg-2"}]]

const IconFiltersFilled = createReactComponent('filled', 'filters-filled', 'FiltersFilled', __iconNode);

export default IconFiltersFilled;